export default __webpack_public_path__ + "static/media/psdifferences.a6979a9e.png";